/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { getOptimizedSrcs } from 'js/lib/imgix';

import { Avatar, Tag } from '@coursera/cds-core';

import _t from 'i18n!nls/page';

type Props = {
  user: {
    full_name: string;
    photo_120: string;
    photo: string;
  };
  isCourseraPlusLearner?: boolean;
};

const styles = {
  border: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: -10px;

    button:has(&) {
      margin-left: var(--cds-spacing-50);
    }
  `,
  avatarWrapper: css`
    &.cds-Avatar-showBorder {
      border: 2px solid var(--cds-color-interactive-primary);
    }
  `,
  avatarOverrides: css`
    .cds-Avatar-initialText {
      font-size: 16px;
    }

    img {
      vertical-align: unset;
    }
  `,
  plusBadge: css`
    padding: 0 6px;
    position: relative;
    top: -8px;
    height: 10px;

    span {
      font-size: 8px;
    }

    &.cds-tag-status.cds-tag-primary.cds-tag-default {
      background-color: var(--cds-color-interactive-primary);
      border-color: var(--cds-color-interactive-primary);
    }
  `,
};

const SIZE = 24;

const UserPortraitV2 = ({ user, isCourseraPlusLearner }: Props) => {
  const { full_name: fullName, photo_120: photoUrl, photo: defaultPhoto } = user;
  const firstName = fullName && fullName.split(' ')[0];

  const srcs = getOptimizedSrcs(photoUrl || defaultPhoto, SIZE, SIZE);
  const srcSet = srcs.dpr2 && srcs.dpr3 && `${srcs.dpr2} 2x, ${srcs.dpr3} 3x`;
  const src = srcs.dpr1;

  return (
    <div className="pii-hide" css={isCourseraPlusLearner && styles.border}>
      <Avatar
        variant="user"
        data-testid="user-avatar"
        initial={firstName?.[0]}
        imgProps={{
          src,
          alt: _t('Profile image for #{learnerName}', { learnerName: fullName }),
          srcSet,
          fetchpriority: 'low',
        }}
        css={[isCourseraPlusLearner && styles.avatarWrapper, styles.avatarOverrides]}
        showBorder={isCourseraPlusLearner}
        size={SIZE}
      />
      {isCourseraPlusLearner && (
        <Tag variant="status" priority="primary" css={styles.plusBadge}>
          PLUS
        </Tag>
      )}
    </div>
  );
};

export default UserPortraitV2;
